// INFO: 컨퍼런스 페이지에서 사용되는 credential 은 wavve 사용자의 credentail을 사용하면 안된다.
// 일반 API 호출시 에는 credential 'none'
// 스트리밍 호출 시에는 외부에서 받아오는 credential 을 강제로 사용한다.
import axios from 'axios'
import { makeRequest } from '@/common/utils/request.common'
import _ from 'lodash'
import { API_BASE_URL, HTTP_METHOD_GET, HTTP_METHOD_POST } from '@/common/utils/request.const'

export const URL_GET_PARTNERS_MAIL_LIST = `${API_BASE_URL}/partner/meet/list`
export const URL_POST_REQUEST_PARTNER_AUTH_MAIL = `${API_BASE_URL}/partner/meet/regist`
export const URL_POST_AUTHENTICATE_CODE = `${API_BASE_URL}/partner/meet/authenticate`
export const URL_POST_PRE_DEPLOY_AUTH_CODE = `${API_BASE_URL}/partner/meet/authcode`

const setCredentialToNone = req => _.set(req, 'params.credential', 'none')

export const getPartnersMailList = () => {
  return axios(setCredentialToNone(makeRequest({
    url: URL_GET_PARTNERS_MAIL_LIST,
    method: HTTP_METHOD_GET
  })))
}

export const postRequestAuthMail = ({ groupcode, membercode, email }) => {
  return axios(setCredentialToNone(makeRequest({
    url: URL_POST_REQUEST_PARTNER_AUTH_MAIL,
    method: HTTP_METHOD_POST,
    data: { groupcode, membercode, email }
  })))
}

export const postAuthenticateCode = ({ email, authenticatecode }) => {
  return axios(setCredentialToNone(makeRequest({
    url: URL_POST_AUTHENTICATE_CODE,
    method: HTTP_METHOD_POST,
    data: { email, authenticatecode }
  })))
}

export const getConferenceMetaInfo = () => {
  const dummyData = {
    channelid: 'F9999',
    credential: 'nD1qotSD61Jv4eqhAvTAoxxpZT+f4eU42wmevGwhYiHY2g0i2ynuSR3xdnAevhzrglk2Zzf+ohgTzjx62A48Zy2jtT/NWi18BWbkU0F6+BdRpc7TOFHPTvzSAFT+afTb',
    sendbird_url: 'sendbird_open_channel_1737_f8501c20268f1652f8a0c401140ba776cc0db788',
    login_info: {
      title: '[CEO Townhall]</br>구성원 여러분의</br>많은 참여 부탁드립니다.',
      subtitle: []
    },
    player_info: {
      title: 'CEO Townhall',
      content: '<ul><li>2021. 10. 12(화) 16:00 ~ 18:00</li></ul>',
      chat_title: '',
      chat_notice: []
    }
  }
  return new Promise((resolve) => {
    resolve(dummyData)
  })
}

export const postAuthenticateCodeWithPreDeployCode = (authCode) => {
  return axios(setCredentialToNone(makeRequest({
    url: URL_POST_PRE_DEPLOY_AUTH_CODE,
    method: HTTP_METHOD_POST,
    data: { authenticatecode: authCode }
  })))
  // const testDummyResponse = {
  //   data: {
  //     'resultcode': '200',
  //     'resultmessage': 'success',
  //     'resultoptional': ''
  //   }
  // }
  // return new Promise((resolve) => {
  //     resolve(testDummyResponse)
  // })
}
